import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStoreActions } from '~/contexts';
import { useAiSearchSubmit } from '~/hooks/useAiSearchSubmit';
import { ErrorResponse } from '~/infra/ErrorResponse';
import { isObject } from '~/infra/isObject';
import { useDraftsAiSearchStore } from '../../hooks/useDraftsAiSearchStore';
const ERROR_CODES = new Set([
    'feature_disabled',
    'llm_timeout',
    'llm_error',
    'llm_invalid_response',
    'llm_schema_validation_failed'
]);
const isErrorCode = (value)=>typeof value === 'string' && ERROR_CODES.has(value);
const mapError = (err)=>{
    const errorResponse = new ErrorResponse(err);
    if (errorResponse.hasStatus([
        404
    ])) return 'feature_disabled';
    const body = errorResponse.body;
    return isObject(body) && isErrorCode(body.error) ? body.error : 'unknown';
};
const DRAFTS_AI_SEARCH_TIMEOUT_MS = 10000;
export const DRAFTS_AI_SEARCH_PARSE_MUTATION_KEY = [
    'draftsAiSearchParse'
];
export const useDraftsAiSearchSubmit = (param)=>{
    let { onExtracted } = param;
    const { api } = useStoreActions();
    const actions = useDraftsAiSearchStore(useShallow((s)=>({
            setAbortInFlight: s.setAbortInFlight,
            setFilter: s.setFilter,
            setError: s.setError,
            setUnsupported: s.setUnsupported,
            setPartial: s.setPartial
        })));
    const invoke = useCallback((args)=>api.draftsAiSearch.invoke(args), []);
    return useAiSearchSubmit({
        mutationKey: DRAFTS_AI_SEARCH_PARSE_MUTATION_KEY,
        invoke,
        actions,
        mapError,
        cannotExtractCode: 'cannot_extract',
        timeoutCode: 'llm_timeout',
        timeoutMs: DRAFTS_AI_SEARCH_TIMEOUT_MS,
        onExtracted
    });
};
